<template>
  <v-dialog v-model="openDialog" width="450">
    <v-card flat class="mx-auto" tile v-if="selectedAttendance">
      <v-toolbar flat dark color="primary">

        <v-toolbar-title class="text.center">Attendance: {{ selectedAttendance.ClassRoom.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <!-- <v-toolbar-items>
          <v-btn dark text @click="dialog = false">
            Update
          </v-btn>
        </v-toolbar-items> -->
      </v-toolbar>

      <v-container grid-list-md pb-0>
        <v-layout row wrap>
          <v-flex shrink>
            <div class="text-center text-h5 ">{{ selectedAttendance.attendanceDate | moment("dddd") }}</div>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <div class="text-center text-h5 ">{{ selectedAttendance.Teacher.name }}</div>
          </v-flex>
        </v-layout>





        <v-layout class="mt-2" row justify-center>
          <v-flex shrink>
            <v-chip v-if="selectedAttendance && selectedAttendance.AttendanceDetails" small class="text-capitalize">
              {{ selectedAttendance.AttendanceDetails.length }} Attendance Taken
            </v-chip>
          </v-flex>
        </v-layout>

      </v-container>

      <!-- <div class="text-center mt-5">
        <v-btn-toggle disabled>
        <v-btn>
          <div>{{totalPresentAttendance}} Present</div>
        </v-btn>
        <v-btn>
          <div>{{totalPresentAttendance}} Present</div>
        </v-btn>
        <v-btn>
          <div>{{totalPresentAttendance}} Present</div>
        </v-btn>
        <v-btn>
          <div>{{totalPresentAttendance}} Present</div>
        </v-btn>
      </v-btn-toggle>
         this.totalAbsentAttendance = 0
      this.totalLateAttendance = 0
      this.totalLeaveAttendance = 0
      </div> -->

      <v-card-text class="mt-5">
        <v-layout row wrap>
          <v-flex>
            <v-card outlined flat color="teal darken-2" class="py-2 rounded-lg rounded-r-0" dark>
              <div class="text-center font-weight-bold">{{ totalPresentAttendance }}</div>
              <div class="text-center">Present</div>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card tile outlined flat color="red accent-4" class="py-2" dark>
              <div class="text-center font-weight-bold">{{ totalAbsentAttendance }}</div>
              <div class="text-center">Absent</div>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card tile outlined flat color="brown darken-1" class="py-2" dark>
              <div class="text-center font-weight-bold">{{ totalLateAttendance }}</div>
              <div class="text-center">Late</div>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card outlined flat color="deep-orange lighten-1" class="py-2 rounded-lg rounded-l-0" dark>
              <div class="text-center font-weight-bold">{{ totalLeaveAttendance }}</div>
              <div class="text-center">Leave</div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>


      
      <v-list v-if="attendanceDetails.length" class="view-container"
        :dense="$vuetify.breakpoint.xsOnly">

        <template v-for="(item, index) in attendanceDetails">

          <v-list-item :key="item.Student.fullName" v-if="item.Student">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold text-capitalize">{{
              item.Student.fullName
              }}
              </v-list-item-title>

              <v-list-item-subtitle v-if="item.Student.deletedAt">
                <v-chip small color="red" text-color="white">Removed</v-chip>
              </v-list-item-subtitle>
              <!-- <v-list-item-subtitle v-if="item.femaleStudentLeads !== 0">{{ item.femaleStudentLeads }} - Female
                  </v-list-item-subtitle> -->


            </v-list-item-content>
            <v-list-item-action>
              <!-- <v-list-item-action-text>{{ item.totalStudentLeads }}</v-list-item-action-text> -->
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                   <v-chip 
                      v-bind="attrs"
                      v-on="on"
                      :text-color="statusColor(item.status).fd" 
                      :color="statusColor(item.status).bk" 
                      label
                      style="cursor: pointer;"
                      class="text-capitalize">{{ item.status }}</v-chip>
                </template>
                <v-list dense>
                    <v-list-item @click="item.status = 'present'">
                        <v-list-item-title>Present</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="item.status = 'absent'">
                        <v-list-item-title>Absent</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="item.status = 'late'">
                        <v-list-item-title>Late</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="item.status = 'leave'">
                        <v-list-item-title>Leave</v-list-item-title>
                    </v-list-item>
                </v-list>
              </v-menu>

            </v-list-item-action>
          </v-list-item>

          <v-divider v-if="index < attendanceDetails.length - 1" :key="index"></v-divider>
        </template>

      </v-list>
  
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn v-if="selectedAttendance.id" color="accent" :loading="isSaving" @click="updateAttendance">Update</v-btn>
        <v-btn v-else color="primary" :loading="isSaving" @click="createAttendance">Save</v-btn>
      </v-card-actions>

    </v-card>
    <v-dialog v-model="dialog" width="300">

      <v-card v-if="selectedStudent">
        <ModelTitle :title="selectedStudent.Student.fullName" @close="closeAttBox" />
        <v-container grid-list-lg>

          <div class="text-center mt-2">
            <v-layout row wrap>
              <v-flex xs12 v-for="(item, i) in selectionObj" :key="i">
                <v-btn large @click="submitSelection(item)" :color="item.color" :dark="item.dark" block>{{ item.label }}
                </v-btn>
              </v-flex>
            </v-layout>

          </div>
        </v-container>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = !dialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-dialog>





</template>

<script>
import attService from '@/modules/TeacherModules/Attendance/service.js'
import classRoomService from "@/modules/ClassRoom/service.js";

export default {
  name: 'admin-student-profile',
  props: ['openDialog', 'selectedAttendance'],
  data() {
    return {
      isSaving: false,
      attendanceDetails: [],
      OrgStudents: [],
      Attendance: null,
      selectedOption: null,
      selection: ['present', 'absent', 'late', 'leave'],
      selectionObj: [
        { label: 'present', color: 'teal darken-2', dark: true },
        { label: 'absent', color: 'red accent-4', dark: true },
        { label: 'late', color: 'brown darken-1', dark: true },
        { label: 'leave', color: 'deep-orange lighten-1', dark: true },
      ],
      option: null,
      dialog: null,
      selectedDate: this.$moment(),
      createDate: this.$moment(),
      todayDate: this.$moment(),
      Students: [],
      selectedStudent: null,
    }
  },
  // created() {
  //   // console.log('created call')
  //   this.calculateAtt()
  // },
  // watch: {
  //   openDialog(val) {
  //     console.log('start', val)
  //     if (val) {
  //       this.calculateAtt()
  //     }
  //   }
  // },
  // computed: {
  //   // ...mapGetters("teacherLayout", ["getClassRoom", "getTeacherStore"]),
  //   // selectedAttendance: {
  //   //   get() {
  //   //     return this.getClassRoom
  //   //   },
  //   //   set(val) {
  //   //     this.setClassRoom(val)
  //   //   }
  //   // },
  //   // Teacher: {
  //   //   get() {
  //   //     return this.getTeacherStore
  //   //   },
  //   //   set(val) {
  //   //     this.setTeacher(val)
  //   //   }
  //   // },
  // },
  watch: {
    selectedAttendance(val) {
      if (val && val.AttendanceDetails) {
        this.attendanceDetails = JSON.parse(JSON.stringify(val.AttendanceDetails));
      }
      this.calculateAtt()
    },
    attendanceDetails: {
        handler() {
            this.calculateAtt();
        },
        deep: true
    }
  },
  methods: {
    calculateAtt() {
      this.totalPresentAttendance = 0
      this.totalAbsentAttendance = 0
      this.totalLateAttendance = 0
      this.totalLeaveAttendance = 0
      this.attendanceDetails.map(row => {
        switch (row.status) {
          case 'present':
            this.totalPresentAttendance++
            break;
          case 'absent':
            this.totalAbsentAttendance++
            break;
          case 'leave':
            this.totalLeaveAttendance++
            break;
          case 'late':
            this.totalLateAttendance++
            break;

        }
      })
    },
    // ...mapActions("teacherLayout", ['setClassRoom', 'setTeacher']),
    createAttendance(){
      this.isSaving = true;
      const payload = {
        ...this.selectedAttendance,
        AttendanceDetail: this.attendanceDetails,
        ClassId: (this.attendanceDetails[0] && this.attendanceDetails[0].Student && this.attendanceDetails[0].Student.ClassStudents[0] ) ? this.attendanceDetails[0].Student.ClassStudents[0].ClassId : null
      };
      return attService.create(payload)
      .then((result) => {
        if (result.status == 409) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: result.data.message,
            });
            this.loading = false;
            return false
        }
        this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        })
        .fire({
          icon: "success",
          title: "Attendance is updated",
        });
        this.$emit('update-success');
        this.close();
        this.isSaving = false
      }).catch((err) => {
        console.log("err", err);
        this.loading = false;
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: err.data.message,
          });
        this.close();
      });
    },
    updateAttendance() {
      this.isSaving = true;
      const payload = {
        details: this.attendanceDetails
      };
      return attService.updateAttendanceDetails(payload)
      .then((result) => {
        if (result.status == 409) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: result.data.message,
            });
            this.loading = false;
            return false
        }
        this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        })
        .fire({
          icon: "success",
          title: "Attendance is update",
        });
        this.$emit('update-success');
        this.close();
        this.isSaving = false
      }).catch((err) => {
        console.log("err", err);
        this.loading = false;
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: err.data.message,
          });
        this.close();
      });
    },
    
    close() {
      this.$emit('close')
    },
    resetList() {
      this.listItems = [
        { count: 0, status: 'present' },
        { count: 0, status: 'absent' },
        { count: 0, status: 'late' },
        { count: 0, status: 'leave' },
        { count: 0, status: 'not set' }
      ]
    },
    getCount(status) {
      // console.log('status', status)
      this.Students.map(row => {
        let count = 0
        if (status === row.status) {
          count++
        }
        // console.log('status', count)
        return count
      })
    },
    statusColor(status) {
      let color = {
        bk: 'grey lighten-3',
        fd: 'black'
      }
      switch (status) {
        case 'present':
          color = {
            bk: 'teal darken-2',
            fd: 'white'
          }
          break;
        case 'absent':
          color = {
            bk: 'red accent-4',
            fd: 'white'
          }
          break;
        case 'late':
          color = {
            bk: 'brown darken-1',
            fd: 'white'
          }
          break;
        case 'leave':
          color = {
            bk: 'deep-orange lighten-1',
            fd: 'white'
          }
          break;
        default:
          color = {
            bk: 'grey lighten-3',
            fd: 'black'
          }
          break;
      }

      return color
    },
    // closeAttBox() {
    //   this.dialog = !this.dialog
    //   this.selectedStudent = null
    // },

    // takeAtt(student) {
    //   this.selectedStudent = student
    // },
    // openAtt(student) {
    //   // console.log('student att', student)
    //   this.selectedStudent = student
    //   this.dialog = !this.dialog
    // },
    getStudent() {
      return classRoomService.getAssignStudentList({ ClassRoomId: this.selectedAttendance.ClassRoomId })
        .then(response => {
          // console.log('student att', response)

          this.Students = response.data
          this.Students.map(row => {
            row.status = 'not set'
          })
          this.OrgStudents = JSON.parse(JSON.stringify(this.Students))
        })
    },
    getAtt() {
      this.Attendance = null
      // const now = this.$moment()
      // now.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      // console.log(now.toISOString());
      // console.log('now ' + now.toISOString())
      // console.log('start ' + now.startOf('day').toISOString())
      // console.log('end ' + now.endOf('day').toISOString())

      // var m = moment();



      // console.log('this.selectedDate.startOf(', this.selectedDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 }))
      // console.log('start of today', this.selectedDate.utc().startOf('day').toISOString())
      // console.log('end of today', this.selectedDate.utc().endOf('day').toISOString())
      const where = {
        start: this.selectedDate.utc().startOf('day').toISOString(),
        end: this.selectedDate.utc().endOf('day').toISOString(),
        ClassRoomId: this.selectedAttendance.ClassRoomId
      }
      // console.log('where', where)
      return attService.getAll(where)
        .then(response => {
          // console.log('getAtt getAtt', response)
          this.Attendance = response.data[0]

          this.setAttendance()
        })
    },
    setAttendance() {
      // this.resetList()
      // let listToDelete = []

      this.Students = JSON.parse(JSON.stringify(this.OrgStudents))
      // this.Students.map(row => {
      //   row.status = 'not set'
      // })

      if (this.Attendance && this.Attendance.AttendanceDetails.length > 0) {
        // console.log('this.Attendance', this.Attendance, this.Students)
        this.Students.map((student) => {
          // console.log('found it', student.StudentId)
          this.Attendance.AttendanceDetails.map(att => {
            // console.log('student', student)
            if (student.StudentId === att.StudentId) {
              // console.log('found it', student.StudentId, att.StudentId, index)
              // listToDelete.push(student)
              student.status = att.status
              // this.Students.splice(index, 1)
            }

            // if (att.StudentId === row.StudentId) {
            //   row.status = att.status
            //   row.AttendanceDetailsId = att.id
            // }
          })




        })

        // console.log('index', listToDelete)
        // for (var i = 0; i < listToDelete.length; i++) {
        //   var obj = listToDelete[i];
        //   // console.log('test', listToDelete.indexOf(obj.StudentId))

        //   const index = this.Students.findIndex(object => {
        //     return obj.StudentId === object.StudentId
        //   });

        //   // console.log(index);
        //   if (index !== -1) {
        //     // console.log(this.Students[index])
        //     this.Students.splice(index, 1);
        //   }

        //   // if (listToDelete.indexOf(obj.StudentId) !== -1) {
        //   //   console.log('found it')
        //   //   // this.Students.splice(i, 1);
        //   // }
        // }
        // removeIndex.map(idx => {
        //   // this.Students.splice(idx, 1)
        //   console.log('index view', this.Students[idx].Student.fullName)
        //   this.Students.splice(idx, 1)
        // })

      }

    },
    minus() {
      // console.log('minus', this.selectedDate)
      this.selectedDate = this.$moment(this.selectedDate).subtract(1, 'day');
      this.createDate = this.$moment(this.createDate).subtract(1, 'day');
      this.Students = this.OrgStudents
      this.getAtt()
    },
    plus() {
      // console.log('plus', this.todayDate.toISOString(), this.selectedDate.toISOString())
      this.selectedDate = this.$moment(this.selectedDate).add(1, 'day');
      this.createDate = this.$moment(this.createDate).add(1, 'day');
      this.Students = this.OrgStudents
      this.getAtt()

      // this.selectedDate.add(1, 'd');
    }
  }
}
</script>

<style scoped>
.view-container {
  max-height: 400px; /* Height ko max-height se badla aur value kam ki */
  width: 100%;
  overflow: auto;
}
</style>